'use strict';
import Config from 'js/config';

module.exports = {
  generateGroupImageUrl(groupCode) {
    if(!groupCode) {
      return Config.defaultProfileImage;
    }
    return Config.cdn.communityLogos + groupCode + Config.groups.suffix;
  },

  generateGroupBannerUrl(groupCode) {
    if(!groupCode) {
      return Config.defaultBannerImage;
    }
    return Config.cdn.communityBanners + groupCode + Config.groups.bannerSuffix;
  },

  generateAvatarLink(user) {
    if (!user) {
      return Config.defaultProfileImage;
    }

    return user.imageUrl || user.profileImageSmall || (Config.cdn.avatars + user.userImageHash + Config.avatars.smallSuffix);
  },

  // this is to be used to reload the page to switch from BG to solaris-fe
  clickAndRefresh(e, href) {
    e.preventDefault();
    window.location.href = href;
  },

  redirectAndShowSignUp({ noClose = false } = {}) {
    const currentCommunity = window.app.context.getGroup();
    const communitySlug = !!currentCommunity ? currentCommunity.groupCode : '';
    const noCloseParams = noClose ? '&exit=0' : '';
    window.location.href = `/${communitySlug}?popup=1${noCloseParams}`;
  },
};



// WEBPACK FOOTER //
// ./app/assets/js/linkUtils.js